<script lang="ts">
	import { Responsive } from "responsive"
	import { AccountNavigator } from "../../AccountStore"
	import SubmenuHeading from "../generic/SubmenuHeading.svelte"
	import { closeOverlay, openConfirmOverlay } from "overlay"

	function goBack() {
		AccountNavigator.closeSubscription()
	}

	function cancelSubscription() {
		const overlayID = openConfirmOverlay({
			prompt: ["Need to cancel your subscription? Reach out, and we’ll handle it promptly."],
			buttons: {
				deny: {
					text: "Nevermind",
					onClick: () => closeOverlay(overlayID),
				},
				confirm: {
					text: "Continue",
					onClick: () =>
						window.open("https://luxhome.ai/pages/help?hcUrl=%2Fen-US%2Fcontact", "_blank"),
				},
			},
		})
	}
</script>

<SubmenuHeading onBack={goBack}>
	<div class="heading-content">
		<h2>Cancel LuxLink Subscription</h2>
		<span
			>{Responsive.isMobile ? "Tap" : "Click"} the "Cancel Subscription" button below to cancel your
			subscription.</span
		>
	</div>
</SubmenuHeading>

<div class="cancel-text-container">
	<p>
		Are you sure you want to cancel your subscription?
		<br />
		If so, you will be able to continue using LuxLink until the end of your current billing cycle, after
		which you will not be charged and the subscription will be terminated.
	</p>
</div>

<div class="button-container">
	<button class="link-button" onclick={goBack}>Go Back</button>
	<button class="warn" onclick={cancelSubscription}>Cancel Subscription</button>
</div>

<style>
	h2 {
		font-size: var(--h1);
		margin: 0;
	}

	.heading-content {
		display: flex;
		flex-direction: column;
	}

	.heading-content span {
		font-size: var(--h3);
	}

	.cancel-text-container {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	p {
		color: var(--color-text);
	}

	.button-container {
		width: fit-content;
		position: absolute;
		bottom: 1rem;
		right: 2rem;
	}
</style>
